import { useErrorCodeTranslation } from "./errors";

import type { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";
import type { YupValidationError } from "../models/ValidationError";

type Error = FieldError | Merge<FieldError, FieldErrorsImpl<any>>;

const castFieldError = (fieldError?: Error) =>
  (fieldError as unknown) as Omit<FieldError, "message"> & YupValidationError;

export function useErrorProps(fieldError?: Error) {
  const { et } = useErrorCodeTranslation();
  const castedFieldError = castFieldError(fieldError);

  if (!castedFieldError) {
    return { error: false } as const;
  }

  if (typeof castedFieldError.message === "string") {
    return {
      error: true,
      helperText: et(castedFieldError.message),
    } as const;
  }

  return {
    error: true,
    helperText: et(
      castedFieldError.message.key,
      castedFieldError.message.values
    ),
  } as const;
}
